import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, MapPin } from "lucide-react";
import { NAV_LINKS, ADDRESS, PHONE, PHONE_TEL, HOURS, INSTAGRAM_URL } from "../../data/site";
import { Sparkle } from "./Sparkle";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-espresso text-ivory border-t border-gold/40"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="/assets/logo-light.png"
            alt="S & Z Hair and Laser"
            className="h-16 w-auto mb-6"
          />
          <p className="font-sans uppercase tracking-[0.22em] text-[11px] text-champagne/80">
            S &amp; Z Hair and Laser — Brampton, Ontario
          </p>
          <p className="font-quote italic text-xl text-ivory/70 mt-5 max-w-sm">
            Precision. Presence. Quiet luxury.
          </p>
          <div className="flex items-center gap-5 mt-8">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
              className="text-gold hover:text-champagne transition-colors duration-300"
            >
              <Instagram size={18} strokeWidth={1.25} />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              aria-label="Facebook"
              className="text-gold hover:text-champagne transition-colors duration-300"
            >
              <Facebook size={18} strokeWidth={1.25} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-sans uppercase tracking-[0.22em] text-[11px] text-gold mb-6 flex items-center gap-2">
            <Sparkle size={10} /> Explore
          </h3>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-link-${l.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="font-sans uppercase tracking-[0.18em] text-xs text-ivory/60 hover:text-champagne transition-colors duration-300"
                >
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="font-sans uppercase tracking-[0.22em] text-[11px] text-gold mb-6 flex items-center gap-2">
            <Sparkle size={10} /> Visit the Studio
          </h3>
          <p className="flex items-start gap-3 text-sm text-ivory/70 leading-relaxed">
            <MapPin size={16} strokeWidth={1.25} className="text-gold mt-1 shrink-0" />
            {ADDRESS}
          </p>
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-sm text-ivory/70 mt-4 hover:text-champagne transition-colors duration-300"
          >
            <Phone size={16} strokeWidth={1.25} className="text-gold shrink-0" />
            {PHONE}
          </a>
          <ul className="mt-6 space-y-2 border-t border-ivory/10 pt-6">
            {HOURS.map((h) => (
              <li
                key={h.day}
                className="flex justify-between font-sans uppercase tracking-[0.15em] text-[11px] text-ivory/50"
              >
                <span>{h.day}</span>
                <span className="text-champagne/80">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="font-sans uppercase tracking-[0.2em] text-[10px] text-ivory/40">
          © {new Date().getFullYear()} S &amp; Z Hair and Laser. All rights reserved.
        </p>
        <p className="font-sans uppercase tracking-[0.2em] text-[10px] text-ivory/40 flex items-center gap-2">
          Where Beauty Meets Precision <Sparkle size={9} />
        </p>
      </div>
    </div>
  </footer>
);
